import { Pipe, PipeTransform } from '@angular/core';
import { formatDistanceToNow } from 'date-fns';

@Pipe({
  name: 'timeAgo',
})
export class TimeAgoPipe implements PipeTransform {
  transform(date: Date | string | number): string {
    if (!date) return '';

    return formatDistanceToNow(new Date(date), {
      addSuffix: true,
      includeSeconds: true,
    });
  }
}
